module.exports = __webpack_public_path__ + "static/media/knife.4e4e8954.svg";